import { render, staticRenderFns } from "./manageNotesDialog.vue?vue&type=template&id=d128bf50"
import script from "./manageNotesDialog.vue?vue&type=script&lang=js"
export * from "./manageNotesDialog.vue?vue&type=script&lang=js"
import style0 from "./manageNotesDialog.vue?vue&type=style&index=0&id=d128bf50&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports